module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }